'use strict';
import './style.css';
import Swiper from 'swiper';
import 'swiper/css';

class BlogList {
    static init() {
        this.initSliders('.blog-list');
    }

    static initSliders(selector) {
        document.querySelectorAll(selector).forEach(list => {
            let swiper = null;

            const destroy = () => {
                if (!swiper) return;

                swiper.destroy(true, true);
                swiper = null;

                const wrapper = list.querySelector(':scope > .swiper-wrapper');
                if (wrapper) {
                    Array.from(wrapper.children).forEach(item => {
                        item.classList.remove('swiper-slide');
                        list.append(item);
                    });
                    wrapper.remove();
                }
                list.classList.remove('swiper');
            };

            const update = () => {
                if (window.innerWidth >= 768) {
                    destroy();
                    return;
                }

                if (swiper) return;

                const items = Array.from(list.children);
                if (items.length < 2) return;

                const wrapper = document.createElement('div');
                wrapper.className = 'swiper-wrapper';
                items.forEach(item => {
                    item.classList.add('swiper-slide');
                    wrapper.append(item);
                });
                list.append(wrapper);
                list.classList.add('swiper');

                swiper = new Swiper(list, {
                    centeredSlides: true,
                    loop: items.length > 2,
                    slidesPerView: 1,
                    spaceBetween: 10,
                    breakpoints: {
                        500: {
                            slidesPerView: 'auto'
                        }
                    }
                });
            };

            update();
            window.addEventListener('resize', update);
            window.addEventListener('orientationchange', update);
        });
    }
}

export {BlogList};